// extracted by mini-css-extract-plugin
module.exports = {"patternMap":"PatternMap_patternMap__3QlHR","info":"PatternMap_info__186rT"};